import { normalizeInteractionText } from './core';

/** Metadata is supplied by the English CMS branch/resources, never by visible UI text. */
export function readEnglishAnalyticsText(
  element: Element | null | undefined,
  attribute = 'data-int-text'
): string {
  return normalizeInteractionText(element?.getAttribute?.(attribute));
}
